import { useContext, useState } from 'react'
import { Panel, Button, Alert } from 'rsuite'
import CartItemsTable from './CartItemsTable'
import { useTranslation } from 'react-i18next'
import { SatImgContext } from '../../../contexts/DataProviderContext'
import API from '../../../api'
import { NavigationContext } from '../../../contexts/NavigationContext'
import axios from 'axios'
// import Halyk from '../../../payment-api'
const qs = require('qs')
const FormData = require('form-data')

const Cart = (props) => {
  const { t } = useTranslation()
  const { chosenTiles, setChosenTiles } = useContext(SatImgContext)
  const { setNavItemId } = useContext(NavigationContext)

  const [summ, setSumm] = useState({
    sumKZT: 0,
    sumUSD: 0
  })

  const [order, setOrder] = useState({})

  function encodeParams (params) {
    if (params === undefined || params === null) { return '' }

    if (typeof params !== 'object') { return '' + params }

    const result = []

    for (const name in params) {
      if (name) {
        result.push(name + '=' + encodeURIComponent(encodeParams(params[name])))
      }
    }

    return result.join('&')
  }
  /* eslint-disable */
    const LZString = (function () { function o (o, r) { if (!t[o]) { t[o] = {}; for (let n = 0; n < o.length; n++) { t[o][o.charAt(n)] = n } } return t[o][r] } const r = String.fromCharCode; const n = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='; const e = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-$'; var t = {}; var i = { compressToBase64: function (o) { if (o == null) { return '' } const r = i._compress(o, 6, function (o) { return n.charAt(o) }); switch (r.length % 4) { default: case 0: return r; case 1: return r + '==='; case 2: return r + '=='; case 3: return r + '=' } }, decompressFromBase64: function (r) { return r == null ? '' : r == '' ? null : i._decompress(r.length, 32, function (e) { return o(n, r.charAt(e)) }) }, compressToUTF16: function (o) { return o == null ? '' : i._compress(o, 15, function (o) { return r(o + 32) }) + ' ' }, decompressFromUTF16: function (o) { return o == null ? '' : o == '' ? null : i._decompress(o.length, 16384, function (r) { return o.charCodeAt(r) - 32 }) }, compressToUint8Array: function (o) { for (var r = i.compress(o), n = new Uint8Array(2 * r.length), e = 0, t = r.length; t > e; e++) { const s = r.charCodeAt(e); n[2 * e] = s >>> 8, n[2 * e + 1] = s % 256 } return n }, decompressFromUint8Array: function (o) { if (o === null || void 0 === o) { return i.decompress(o) } for (var n = new Array(o.length / 2), e = 0, t = n.length; t > e; e++) { n[e] = 256 * o[2 * e] + o[2 * e + 1] } const s = []; return n.forEach(function (o) { s.push(r(o)) }), i.decompress(s.join('')) }, compressToEncodedURIComponent: function (o) { return o == null ? '' : i._compress(o, 6, function (o) { return e.charAt(o) }) }, decompressFromEncodedURIComponent: function (r) { return r == null ? '' : r == '' ? null : (r = r.replace(/ /g, '+'), i._decompress(r.length, 32, function (n) { return o(e, r.charAt(n)) })) }, compress: function (o) { return i._compress(o, 16, function (o) { return r(o) }) }, _compress: function (o, r, n) { if (o == null) { return '' } let e; let t; let i; const s = {}; const p = {}; let u = ''; let c = ''; let a = ''; let l = 2; let f = 3; let h = 2; const d = []; let m = 0; let v = 0; for (i = 0; i < o.length; i += 1) { if (u = o.charAt(i), Object.prototype.hasOwnProperty.call(s, u) || (s[u] = f++, p[u] = !0), c = a + u, Object.prototype.hasOwnProperty.call(s, c)) { a = c } else { if (Object.prototype.hasOwnProperty.call(p, a)) { if (a.charCodeAt(0) < 256) { for (e = 0; h > e; e++) { m <<= 1, v == r - 1 ? (v = 0, d.push(n(m)), m = 0) : v++ } for (t = a.charCodeAt(0), e = 0; e < 8; e++) { m = m << 1 | 1 & t, v == r - 1 ? (v = 0, d.push(n(m)), m = 0) : v++, t >>= 1 } } else { for (t = 1, e = 0; h > e; e++) { m = m << 1 | t, v == r - 1 ? (v = 0, d.push(n(m)), m = 0) : v++, t = 0 } for (t = a.charCodeAt(0), e = 0; e < 16; e++) { m = m << 1 | 1 & t, v == r - 1 ? (v = 0, d.push(n(m)), m = 0) : v++, t >>= 1 } }l--, l == 0 && (l = Math.pow(2, h), h++), delete p[a] } else { for (t = s[a], e = 0; h > e; e++) { m = m << 1 | 1 & t, v == r - 1 ? (v = 0, d.push(n(m)), m = 0) : v++, t >>= 1 } }l--, l == 0 && (l = Math.pow(2, h), h++), s[c] = f++, a = String(u) } } if (a !== '') { if (Object.prototype.hasOwnProperty.call(p, a)) { if (a.charCodeAt(0) < 256) { for (e = 0; h > e; e++) { m <<= 1, v == r - 1 ? (v = 0, d.push(n(m)), m = 0) : v++ } for (t = a.charCodeAt(0), e = 0; e < 8; e++) { m = m << 1 | 1 & t, v == r - 1 ? (v = 0, d.push(n(m)), m = 0) : v++, t >>= 1 } } else { for (t = 1, e = 0; h > e; e++) { m = m << 1 | t, v == r - 1 ? (v = 0, d.push(n(m)), m = 0) : v++, t = 0 } for (t = a.charCodeAt(0), e = 0; e < 16; e++) { m = m << 1 | 1 & t, v == r - 1 ? (v = 0, d.push(n(m)), m = 0) : v++, t >>= 1 } }l--, l == 0 && (l = Math.pow(2, h), h++), delete p[a] } else { for (t = s[a], e = 0; h > e; e++) { m = m << 1 | 1 & t, v == r - 1 ? (v = 0, d.push(n(m)), m = 0) : v++, t >>= 1 } }l--, l == 0 && (l = Math.pow(2, h), h++) } for (t = 2, e = 0; h > e; e++) { m = m << 1 | 1 & t, v == r - 1 ? (v = 0, d.push(n(m)), m = 0) : v++, t >>= 1 } for (;;) { if (m <<= 1, v == r - 1) { d.push(n(m)); break }v++ } return d.join('') }, decompress: function (o) { return o == null ? '' : o == '' ? null : i._decompress(o.length, 32768, function (r) { return o.charCodeAt(r) }) }, _decompress: function (o, n, e) { let t; let i; let s; let p; let u; let c; let a; let l; const f = []; let h = 4; let d = 4; let m = 3; let v = ''; const w = []; const A = { val: e(0), position: n, index: 1 }; for (i = 0; i < 3; i += 1) { f[i] = i } for (p = 0, c = Math.pow(2, 2), a = 1; a != c;) { u = A.val & A.position, A.position >>= 1, A.position == 0 && (A.position = n, A.val = e(A.index++)), p |= (u > 0 ? 1 : 0) * a, a <<= 1 } switch (t = p) { case 0: for (p = 0, c = Math.pow(2, 8), a = 1; a != c;) { u = A.val & A.position, A.position >>= 1, A.position == 0 && (A.position = n, A.val = e(A.index++)), p |= (u > 0 ? 1 : 0) * a, a <<= 1 }l = r(p); break; case 1: for (p = 0, c = Math.pow(2, 16), a = 1; a != c;) { u = A.val & A.position, A.position >>= 1, A.position == 0 && (A.position = n, A.val = e(A.index++)), p |= (u > 0 ? 1 : 0) * a, a <<= 1 }l = r(p); break; case 2: return '' } for (f[3] = l, s = l, w.push(l); ;) { if (A.index > o) { return '' } for (p = 0, c = Math.pow(2, m), a = 1; a != c;) { u = A.val & A.position, A.position >>= 1, A.position == 0 && (A.position = n, A.val = e(A.index++)), p |= (u > 0 ? 1 : 0) * a, a <<= 1 } switch (l = p) { case 0: for (p = 0, c = Math.pow(2, 8), a = 1; a != c;) { u = A.val & A.position, A.position >>= 1, A.position == 0 && (A.position = n, A.val = e(A.index++)), p |= (u > 0 ? 1 : 0) * a, a <<= 1 }f[d++] = r(p), l = d - 1, h--; break; case 1: for (p = 0, c = Math.pow(2, 16), a = 1; a != c;) { u = A.val & A.position, A.position >>= 1, A.position == 0 && (A.position = n, A.val = e(A.index++)), p |= (u > 0 ? 1 : 0) * a, a <<= 1 }f[d++] = r(p), l = d - 1, h--; break; case 2: return w.join('') } if (h == 0 && (h = Math.pow(2, m), m++), f[l]) { v = f[l] } else { if (l !== d) { return null }v = s + s.charAt(0) }w.push(v), f[d++] = s + v.charAt(0), h--, s = v, h == 0 && (h = Math.pow(2, m), m++) } } }; return i }()); typeof define == 'function'
    /* eslint-enable */
  const createPaymentObject = function (auth, invoiceId, amount, terminalID, postLink, currency) {
    const user = JSON.parse(localStorage.user)
    const paymentObject = {
      invoiceId,
      backLink: 'https://example.kz/success.html',
      failureBackLink: 'https://example.kz/failure.html',
      postLink,
      failurePostLink: 'https://example.kz/order/1123/fail',
      language: 'rus',
      description: 'Оплата в KGS',
      // accountId: user.email,
      terminal: terminalID,
      amount,
      currency,
      cardSave: true,
      email: user.email,
      phone: user.phone
    }
    paymentObject.auth = auth
    return paymentObject
  }
  const handlePayClick = async (orderID) => {
    const token = await API.order.get_payment_token(orderID)
    console.log(token)
    const params = createPaymentObject(
      {
        access_token: token.access_token,
        expires_in: token.expires_in,
        refresh_token: token.refresh_token,
        scope: token.scope,
        token_type: token.token_type
      },
      token.invoiceId, token.amount, token.terminal, token.postLink, token.currency)
    console.log(params)
    window.open(`https://epay.homebank.kz/payform?params=${LZString.compressToEncodedURIComponent(encodeParams(params))}`)
  }

  const handleBuyClick = async (payNow) => {
    const resultingOrder = await API.cart.submit_cart()
    setOrder(() => resultingOrder)
    setChosenTiles(() => { return [] })
    if (payNow) {
      Alert.success(`Заказ ${resultingOrder?.order?.id} успешно создан! Ожидайте открытия окна оплаты`)
      handlePayClick(resultingOrder?.order?.id)
      setNavItemId(() => { return 1 })
    } else {
      Alert.success(t('Order.Confirmation.request_confirmation_message') + ' ' + resultingOrder?.order?.id)
      setNavItemId(() => { return 1 })
    }

    // let resultingOrder

    // payment api -- DO NOT REMOVE

    // const orderID = resultingOrder?.order?.id
    // const invID = '0000' + orderID
    // const user = JSON.parse(localStorage.user)
    // const amount = summ.sumKZT || 12345678
    // const createPaymentObject = function (auth, invoiceId, amount) {
    //   const paymentObject = {
    //     invoiceId,
    //     backLink: 'https://example.kz/success.html',
    //     failureBackLink: 'https://example.kz/failure.html',
    //     postLink: 'https://example.kz/',
    //     failurePostLink: 'https://example.kz/order/1123/fail',
    //     language: 'rus',
    //     description: 'Оплата в KGS',
    //     accountId: 'testuser1',
    //     terminal: '67e34d63-102f-4bd1-898e-370781d0074d',
    //     amount,
    //     currency: 'KZT',
    //     cardSave: true,
    //     email: user.email,
    //     phone: user.phone
    //   }
    //   paymentObject.auth = auth
    //   return paymentObject
    // }
    // const form = new FormData()
    // form.append('grant_type', 'client_credentials')
    // form.append('scope', 'webapi usermanagement email_send verification statement statistics payment')
    // form.append('client_id', 'test')
    // form.append('client_secret', 'yF587AV9Ms94qN2QShFzVR3vFnWkhjbAK3sG')
    // form.append('invoiceID', invID)
    // form.append('amount', amount)
    // form.append('currency', 'KZT')
    // form.append('terminal', '67e34d63-102f-4bd1-898e-370781d0074d')
    // const token = await axios.post('https://testoauth.homebank.kz/epay2/oauth2/token', form, { headers: { 'Content-Type': 'multipart/form-data' } })
    // const params = createPaymentObject(token.data, invID, amount)
    // console.log(params)
    // window.open(`https://test-epay.homebank.kz/payform?params=${LZString.compressToEncodedURIComponent(encodeParams(params))}`)
  }
  // const hanleBuyClick = () => {
  //   // TODO: check for claculated scenes added and Do I need Order context?
  //   const fetchDataToOrder = async () => {
  //     console.log(await callWidget(4567))
  //     //
  //
  //     //

  //
  //     //

  //     // callWidget()
  //     // setTimeOut(setNavItemId(() => { return 2 }), 500)
  //   }
  //   fetchDataToOrder()
  // }

  return (
    <div className='p-15' id='fourth-step'>
      <h5 className='p-15'>{t('Cart.title')}</h5>

      {/* <Panel bordered style={{ height: props.height / 10 }}>
        <p className='text-center'><small>{t('Cart.info')}</small></p>
      </Panel> */}
      {/* <Panel bordered style={{ height: props.height * 9 / 10 }} bodyFill> */}
      <Panel bordered style={{ height: '878px' }} bodyFill>
        {/* <h5>{t('Cart.list')}</h5> */}
        <CartItemsTable height={props.height * 7 / 10} summ={summ} setSumm={setSumm} />
        {/* <CartItemsList height={props.height * 7 / 10} /> */}
        {/* <CartItemsList /> */}
        <div className='text-center'>
            <div>
              <h6>
                {t('Common.price')}: <b className='color-highlight'>{new Intl.NumberFormat('kz-KZ', { style: 'currency', currency: 'KZT', minimumFractionDigits: 2 }).format(summ.sumKZT)}</b>
                <br />
                USD <span>{new Intl.NumberFormat('us-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2 }).format(summ.sumUSD)}</span>
              </h6>
              </div>
        </div>
        <div className='text-center p-15'>
          <Button appearance='primary' color='orange' onClick={() => handleBuyClick(true)}>{t('Common.pay_now')}</Button>&nbsp;
          <Button appearance='primary' onClick={() => handleBuyClick(false)}>{t('Cart.order')}</Button>
        </div>
      </Panel>
    </div>
  )
}

export default Cart
